import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import {AccountRequests} from "../../services/account-requests.service";
import {AccountsAlerts} from "../../services/accounts-alerts.service";
import {AccountModel} from "../../angular/models/account.model";
import {AccountsService} from "../../services/accounts-service.service";
import {AccountDialogService} from "../../services/account-dialogs-service.service";
import {$accountFactory} from "../../$account.factory";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {DemandAccountType} from "../../types/demand-account.type";
import {AccountsFacadeService} from "../../angular/services/accounts-facade.service";
import {Subscription} from "rxjs";
import {GroupModel} from "../../../groups/models/group.model";
import * as _ from "lodash";
import {ExportAccountsPayloadModel} from "../../models/export-accounts-payload.model";
import {ExportType} from "../../../commons/types/export.type";
import {EXPORT_CSV_SIZE_LIMIT, EXPORT_EXCEL_SIZE_LIMIT} from "../../../commons/angular/constants/commons";
import {AddressQualityEnum} from "../../../addresses/types/address-quality.enum";

export class DemandAccountsCtrl implements IController {

  account: AccountModel;
  branchIds: string[];
  tags: string[];
  addressQualityGroups: AddressQualityEnum[];
  resolvingTypes: string[];
  queryString: string;
  type: any;
  selectedAccount: any;
  isActive: boolean | undefined;

  private filtersConfig: any;
  private totalAccounts: any;
  public isSmallScreen: boolean;
  public accountTypes: string[];
  private accountsSubscription: Subscription;
  private isLoadingAccountsSubscription: Subscription;
  private isInitializedAccountsSubscription: Subscription;
  public accounts: AccountModel[];
  public isLoadingAccounts: boolean;
  public isInitializedAccounts: boolean;
  public groupIds: string[];
  public branchExcludedIds: string[];
  public exportTypes: typeof ExportType = ExportType;
  public addressQualityGroupValues: AddressQualityEnum[];
  public resolvingTypesValues: string[];

  constructor(private $log, private accountDialogService: AccountDialogService, private accountRequests: AccountRequests, private $account: $accountFactory,
              private bringozLoaderService: BringozLoaderService, private accountsService: AccountsService, private $timeout: ITimeoutService,
              private splitService: SplitService, private confirmDialogService: ConfirmDialogService, private accountsAlerts: AccountsAlerts,
              private accountsFacadeService: AccountsFacadeService, private $groups, private $mdMedia, private $translate, private addressResolver,
              private $state) {
  }

  $onInit() {
    this.accountTypes = Object.values(DemandAccountType);
    this.addressQualityGroupValues = Object.values(AddressQualityEnum);
    this.resolvingTypesValues = Object.values(this.addressResolver.resolvingTypes);

    if (!this.branchIds) {
      this.branchIds = [];
    }

    if(!this.addressQualityGroups) {
      this.addressQualityGroups = [];
    }

    if(!this.resolvingTypes) {
      this.resolvingTypes = [];
    }

    this.queryString = undefined;
    this.type = undefined;
    this.selectedAccount = undefined;

    this.getAccounts(this.getQueryParams());

    this.reloadTotalAccounts();

    this.accountsFacadeService.subscribeToChannels();

    this.accountsSubscription = this.accountsFacadeService.selectAll().subscribe(accounts => {
      this.accounts = angular.copy(accounts);
      this.$timeout(() => {
      }, 0)
    });

    this.isLoadingAccountsSubscription = this.accountsFacadeService.selectIsLoading().subscribe((isLoading) => {
      this.isLoadingAccounts = isLoading;
      this.$timeout(() => {
      }, 0)
    });

    this.isInitializedAccountsSubscription = this.accountsFacadeService.selectInitialized().subscribe((initialized) => {
      this.isInitializedAccounts = initialized;
      this.$timeout(() => {
      }, 0)
    });
  }

  $doCheck() {
    this.isSmallScreen = !this.$mdMedia('gt-xs');
  };

  onViewSettingsChange(settings) {
    this.filtersConfig.settings = settings;
    this.splitService.setSiteAccountsSettings(settings);
  }

  changeAccountType(type) {
    this.type = type;
    this.getAccounts(this.getQueryParams());
    this.reloadTotalAccounts();
  }

  onBranchIdsChange(branchIds) {
    this.branchIds = branchIds;
    this.getAccounts(this.getQueryParams());
    this.reloadTotalAccounts();
  }

  onGroupIdsChange(groupIds) {
    this.groupIds = groupIds;
    this.branchExcludedIds = [];
    if (!!groupIds?.length) {
      this.$groups().$asyncValues(groupIds)
        .then((groups) => {
          let groupsBranchIds = [];
          groups.forEach((g: GroupModel) => {
            if (g.branchIds?.length) {
              groupsBranchIds = groupsBranchIds.concat(g.branchIds)
            }
          });
          this.branchExcludedIds = groupsBranchIds;
          this.branchIds = _.uniq(_.concat(this.branchIds || [], groupsBranchIds));
          this.getAccounts(this.getQueryParams());
          this.reloadTotalAccounts();
        })
    }
  }

  onAccountTagsChange(tags) {
    this.tags = tags;
    this.getAccounts(this.getQueryParams());
    this.reloadTotalAccounts();
  }

  onAccountAddressQualityGroupsChange(addressQualityGroups) {
    this.addressQualityGroups = addressQualityGroups;
    this.getAccounts(this.getQueryParams());
    this.reloadTotalAccounts();
  }

  onAccountResolvingTypeChange(resolvingTypes) {
    this.resolvingTypes = resolvingTypes;
    this.getAccounts(this.getQueryParams());
    this.reloadTotalAccounts();
  }

  submitQuery(queryString) {
    this.queryString = queryString;
    this.getAccounts(this.getQueryParams());
    this.reloadTotalAccounts();
  }

  filterByActive(isActive: boolean) {
    this.isActive = this.isActive === isActive ? undefined : isActive;
    this._setStateParams();
    this.getAccounts(this.getQueryParams());
  }


  onCreateAccount(event) {
    this.accountDialogService.createShipperAccount(event)
      .then((createdAccount) => {
        this.getAccounts(this.getQueryParams());
      })
      .catch((error) => {
        this.$log.info('Dialog Closed');
      })
  }

  onSelectAccount(account: AccountModel) {
    this.selectedAccount = account;
    this.$timeout(() => {
    }, 0)
  }

  onDeleteAccount(account, $event) {
    let loading = false;
    const text = 'Are you sure you want to delete this account?';
    this.confirmDialogService.confirmMask('Delete Account', text, $event)
      .then((shouldMask) => {
        loading = true;
        this.bringozLoaderService.on();
        return this.accountRequests.deleteAccount(account.id, shouldMask);
      })
      .then((response) => {
        this.accountsAlerts.demandDeleteOneSuccess();
        this.getAccounts(this.getQueryParams());
        this.selectedAccount = undefined;
        this.$timeout(() => {

        }, 0);
      })
      .catch((error) => {
        if (error) {
          this.accountsAlerts.demandDeleteOneError();
          this.$log.error('Failed to delete account @agentsListView@onDeleteAgent', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        if (loading) {
          this.bringozLoaderService.off();
        }
      })
  }

  onExport(event, exportType: ExportType) {
    const text = 'Are you sure you want to export?';
    let extraText;

    if (exportType === ExportType.Excel) {
      if (this.totalAccounts?.total > EXPORT_EXCEL_SIZE_LIMIT) {
        extraText = 'EXPORT_INFO_LIMIT';
      }
      this.confirmDialogService.confirmWithInfo('Export', text, extraText, {x: EXPORT_EXCEL_SIZE_LIMIT}, event)
        .then(() => {
          this._export(exportType);
        })
        .catch((error) => {
          this.$log.info('Dialog Closed');
        });
    } else if (ExportType.CSV) {
      if (this.totalAccounts?.total > EXPORT_CSV_SIZE_LIMIT) {
        extraText = 'EXPORT_INFO_LIMIT';
      }
      this.confirmDialogService.confirmWithInfo('Export', text, extraText, {x: EXPORT_CSV_SIZE_LIMIT}, event)
        .then(() => {
          this._export(exportType);
        })
        .catch((error) => {
          this.$log.info('Dialog Closed');
        });
    }
  }

  fetchNext() {
    this.accountsFacadeService.fetchNext(this.getQueryParams());
  }

  $onDestroy() {
    this.accountsFacadeService.clearStore();
    this.accountsSubscription.unsubscribe();
    this.isLoadingAccountsSubscription?.unsubscribe();
    this.isInitializedAccountsSubscription?.unsubscribe();
  }


  private reloadTotalAccounts() {
    const archive: boolean = false;
    this.accountRequests.getTotalAccounts(this.branchIds, archive, this.type, this.tags,
        this.addressQualityGroups, this.resolvingTypes)
      .then((total) => {
        this.totalAccounts = total;
      })
      .catch((error) => {
        this.$log.debug('Failed to reload total accounts', error);
      })
  }

  private getAccounts(params) {
    this.accountsFacadeService.clearStore();
    this.accountsFacadeService.getMany(params);
  }

  private getQueryParams() {
    const params = {
      limit: 20,
      isDemand: true,
      type: this.type,
      query: this.queryString,
      tags: this.tags,
      branchIds: this.branchIds,
      addressQualityGroups: this.addressQualityGroups,
      resolvingTypes: this.resolvingTypes,
      isActive: this.isActive
    }

    Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);

    return params;
  }

  private _getExportTablePayload() {
    return {
      accountId: this.$translate.instant('ID'),
      externalId: this.$translate.instant('External ID'),
      accountType: this.$translate.instant('Account Type'),
      accountName: this.$translate.instant('Account Name'),
      phoneNumber: this.$translate.instant('Phone Number'),
      businessCategory: this.$translate.instant('Business Category'),
      branchIds: this.$translate.instant('Branch IDs'),
      address: this.$translate.instant('Address'),
      address1: this.$translate.instant('Address 1'),
      address2: this.$translate.instant('Address 2'),
      country: this.$translate.instant('Country'),
      state: this.$translate.instant('State'),
      city: this.$translate.instant('City'),
      street: this.$translate.instant('Street'),
      house: this.$translate.instant('House'),
      entrance: this.$translate.instant('Entrance'),
      apartment: this.$translate.instant('Apartment'),
      floor: this.$translate.instant('Floor'),
      zipCode: this.$translate.instant('Zipcode'),
      elevator: this.$translate.instant('Elevator'),
      latitude: this.$translate.instant('Latitude'),
      longitude: this.$translate.instant('Longitude'),
      tags: this.$translate.instant('Tags'),
      note: this.$translate.instant('Notes')
    }
  }

  private _export(exportType: ExportType) {
    const payload: ExportAccountsPayloadModel = {
      fieldTranslationMap: this._getExportTablePayload(),
      exportType: exportType,
      accountType: this.type,
      tags: this.tags
    }
    this.accountsService.exportAccounts(payload, this.branchIds, this.type, this.tags, this.isActive);
  }

  private _setStateParams() {
    this.$state.go('.', {
      isActive: this.isActive
    }, {notify: false, reload: false, location: 'replace'});
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('demandAccounts', {
    bindings: {
      account: '<',
      isActive: '<?'
    },
    template: require('./demand-accounts.html').default,
    controller: DemandAccountsCtrl
  });
